const data = [
  {
    id: 1,
    nome: "Francesco Robiola",
    stato: "No pain no Gain XOXO PALESTRA MUSCOLI POTENZA",
    img:
      "https://res.cloudinary.com/thomasdea/image/upload/v1612341193/react-api-course/tizio-palestra_naoqwo.jpg",
    data: "18-04-2026",
    ora: "18:30",
    luogo: "palestra"
  },
  {
    id: 2,
    nome: "Sabrina Cortelli",
    stato: "La musica è per l'anima quello che la ginnastica è per il corpo.",
    img:
      "https://res.cloudinary.com/thomasdea/image/upload/v1612341197/react-api-course/tizia-cuffie_xf2bae.jpg",
    data: "19-05-2026",
    ora: "22:30",
    luogo: "discoteca"
  },
  {
    id: 3,
    nome: "Mike Russel",
    stato: "Non permettere a nessuno di dirti che non sei capace",
    img:
      "https://res.cloudinary.com/thomasdea/image/upload/v1612341184/react-api-course/tizio-giacca_jvzktv.jpg",
     data: "22-06-2026",
    ora: "08:30",
    luogo: "ufficio"
  },
  {
    id: 4,
    nome: "Rebecca Orlando",
    stato:
      "La fotografia è passione e amore, è l’emozione passeggera, che arriva e subito vola via.",
    img:
      "https://res.cloudinary.com/thomasdea/image/upload/v1612341204/react-api-course/tipa-occhiali_svc9jp.jpg",
      data: "20-12-2026",
    ora: "08:30",
    luogo: "Cortina"
  },
  {
    id: 5,
    nome: "Crhistian Minerva",
    stato: "Non mangerei un hamburger nemmeno se mi pagassero 40,000 dollari",
    img:
      "https://res.cloudinary.com/thomasdea/image/upload/v1612341200/react-api-course/tizio_awlq7r.jpg",
     data: "01-08-2026",
    ora: "12:30",
    luogo: "Bali"
  },
];

export default data;
